import $ from 'jquery';
import {changeButton} from '~/functions/tocart';
import * as cart from '../store/cart';
import {addProductToBasket} from '../api/products';

const uRub = '&#8381;';

function getNumberFromString(string) {
    const rawString = string.replace(/[\s\D]/g, '');
    const number = Number(rawString);
    return number;
}

function BuyWith(node) {
    this.root = node;
}

BuyWith.prototype.init = function () {
    const {root} = this;

    if (!root instanceof HTMLElement)
        return new Error('root prop is not a html element');

    const elements = {};

    elements.products = Array.from(root.querySelectorAll('.product-associated-item') || []);
    elements.checkboxes = elements.products.map(elem => elem.querySelector('.product-associated-item__checkbox input[type="checkbox"]'));
    elements.toCartProducts = elements.products.map(elem => elem.querySelector('button[data-tocart]'));
    elements.priceOld = root.querySelector('.product-price__old');
    elements.priceCurrent = root.querySelector('.product-price__current');
    elements.toCart = root.querySelector('.product-associated__button button');

    const prices = {};

    prices.products = elements.products.map(elem => {
        const priceElem = elem.querySelector('.product-associated-item__product-price');

        if (priceElem) {
            const {innerText} = priceElem;
            return getNumberFromString(innerText);
        }

        return 0;
    });
    prices.current = getNumberFromString(elements.priceCurrent.innerText);

    let bxEasing = null;

    function createAnimationCurrentPrice(startVal, finishVal) {
        return new BX.easing({
            start: {
                val: startVal
            },
            finish: {
                val: finishVal
            },
            step: (state) => {
                elements.priceCurrent.innerHTML = `${state.val} ${uRub}`;
            }
        });
    }

    (elements.checkboxes).forEach((checkbox, index, checkboxes) => {
        checkbox.addEventListener('change', function () {
            if (bxEasing)
                bxEasing.stop();

            const checked = checkboxes.filter(elem => elem.checked);

            if (checked.length === 2) {
                (elements.priceOld).hidden = false;
                const startVal = getNumberFromString(elements.priceCurrent.innerText);
                const finishVal = prices.current;
                console.log(elements.priceCurrent);
                bxEasing = createAnimationCurrentPrice(startVal, finishVal);
                bxEasing.animate();
                console.log(elements.priceCurrent);
            } else if (checked.length === 1) {
                (elements.priceOld).hidden = true;
                const checkedIndex = (elements.checkboxes).indexOf(checked[0]);
                const checkedPrice = prices.products[checkedIndex];
                const startVal = getNumberFromString(elements.priceCurrent.innerText);
                const finishVal = checkedPrice;
                bxEasing = createAnimationCurrentPrice(startVal, finishVal);
                bxEasing.animate();
            } else if (checked.length === 0) {
                (elements.priceOld).hidden = true;
                const startVal = getNumberFromString(elements.priceCurrent.innerText);
                const finishVal = 0;
                bxEasing = createAnimationCurrentPrice(startVal, finishVal);
                bxEasing.animate();
            }
        });
    });

    (elements.toCart).addEventListener('click', async function multiAddToCart(event) {
        event.preventDefault();

        const checked = elements.checkboxes.filter(elem => elem.checked);

        if (checked.length === 2) {
            for (let button of elements.toCartProducts) {
                const id = button.getAttribute('data-tocart');

                await addProductToBasket(id);
            }
            cart.update();
            this.removeEventListener('click', multiAddToCart);
            changeButton(this);
        } else if (checked.length === 1) {
            const checkedIndex = (elements.checkboxes).indexOf(checked[0]);
            const checkedProductButton = elements.toCartProducts[checkedIndex];
            checkedProductButton.click();
        }
    });
};

$('.product__associated').each((index, elem) => new BuyWith(elem).init());
